import { render } from "./TheGame.vue?vue&type=template&id=1964b4c9"
import script from "./TheGame.vue?vue&type=script&lang=js"
export * from "./TheGame.vue?vue&type=script&lang=js"
script.render = render

export default script